import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, TrendingUpIcon, TrendingDownIcon, ShareIcon, EyeIcon, HeartIcon, BookmarkIcon, SparklesIcon, ArrowDownIcon, MinusCircleIcon, EyeOffIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <>
      {/* HOOK — El punto de quiebre */}
      <section className="py-12 md:py-32 px-4" style={{
      backgroundColor: '#ffffff'
    }} data-id="element-204">
        <div className="max-w-4xl mx-auto" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="text-center mb-6 md:mb-16" data-id="element-206">
            <span className="text-sm font-bold tracking-[0.2em] uppercase mb-3 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-207">
              ¿QUÉ LOS HACE DIFERENTES?
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6" style={{
            color: '#1A1614'
          }} data-id="element-208">
              El punto de quiebre
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="space-y-5 md:space-y-8" data-id="element-209">
            <p className="text-base md:text-xl" style={{
            color: '#5a5248'
          }} data-id="element-210">
              Hay una diferencia clara entre:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-211">
              <div className="rounded-2xl overflow-hidden bg-gray-50 border border-gray-100" data-id="element-212">
                <img src="https://cdn.magicpatterns.com/uploads/tsJzTJQgnRoJsUohU6hsAW/pasted-image.jpg" alt="Cinnamon roll casero tradicional" className="w-full h-40 md:h-56 object-cover" data-id="element-213" />
                <div className="p-4 md:p-6" data-id="element-214">
                  <p className="text-base md:text-xl font-medium" style={{
                  color: '#5a5248'
                }} data-id="element-215">
                    Un cinnamon roll que se ve{' '}
                    <span className="font-bold" style={{
                    color: '#1A1614'
                  }} data-id="element-216">
                      casero.
                    </span>
                  </p>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-100 bg-white" data-id="element-217">
                <img src="https://cdn.magicpatterns.com/uploads/fq52pphUKzQHE6m4SewRHq/ChatGPT_Image_27_mar_2026,_06_25_50_p.m..png" alt="Cinnamon roll XL estilo bakery moderna" className="w-full h-40 md:h-56 object-cover" data-id="element-218" />
                <div className="p-4 md:p-6" data-id="element-219">
                  <p className="text-base md:text-xl font-medium" style={{
                  color: '#1A1614'
                }} data-id="element-220">
                    Y uno que parece salido de una{' '}
                    <span className="font-bold" style={{
                    color: '#e76f51'
                  }} data-id="element-221">
                      bakery moderna.
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <p className="text-base md:text-xl" style={{
            color: '#5a5248'
          }} data-id="element-222">
              El sabor puede ser bueno en ambos.
            </p>
            <p className="text-base md:text-xl font-bold" style={{
            color: '#1A1614'
          }} data-id="element-223">
              Pero solo uno:
            </p>

            {/* Tray showcase image */}
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5
          }} className="rounded-2xl overflow-hidden shadow-xl" data-id="element-224">
              <img src="https://cdn.magicpatterns.com/uploads/7EN2YtiJD8DYGrAuD8HYkA/ChatGPT_Image_27_mar_2026,_07_06_07_p.m..png" alt="Emely preparando cinnamon rolls XL estilo bakery" className="w-full object-cover" style={{
              maxHeight: '300px'
            }} data-id="element-225" />
            </motion.div>

            <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-226">
              {[{
              icon: EyeIcon,
              text: 'Se fotografía',
              emoji: '📸'
            }, {
              icon: ShareIcon,
              text: 'Se comparte',
              emoji: '🔁'
            }, {
              icon: TrendingUpIcon,
              text: 'Se vende',
              emoji: '📈'
            }, {
              icon: HeartIcon,
              text: 'Se recuerda',
              emoji: '💛'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.4,
              delay: i * 0.1
            }} className="relative overflow-hidden rounded-2xl p-4 md:p-6 shadow-lg border border-gray-100" style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #FFF8F5 100%)'
            }} data-id="element-227">
                  <div className="absolute top-0 right-0 w-16 h-16 rounded-bl-full opacity-20" style={{
                backgroundColor: '#e76f51'
              }} data-id="element-228" />
                  <div className="w-9 h-9 md:w-12 md:h-12 rounded-xl flex items-center justify-center mb-2 md:mb-3" style={{
                backgroundColor: 'rgba(231,111,81,0.12)'
              }} data-id="element-229">
                    <item.icon className="w-4 h-4 md:w-6 md:h-6" style={{
                  color: '#e76f51'
                }} data-id="element-230" />
                  </div>
                  <p className="text-sm md:text-lg font-bold leading-tight" style={{
                color: '#1A1614'
              }} data-id="element-231">
                    {item.text}
                  </p>
                </motion.div>)}
            </div>

            <div className="pt-4 md:pt-8 text-center" data-id="element-232">
              <p className="text-base md:text-xl mb-2" style={{
              color: '#5a5248'
            }} data-id="element-233">
                Y no es cuestión de suerte.
              </p>
              <p className="text-3xl md:text-4xl font-bold" style={{
              color: '#e76f51'
            }} data-id="element-234">
                Es sistema.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* LO QUE ESTÁ PASANDO AHORA */}
      <section className="pt-14 md:pt-32 px-4 pb-0" style={{
      backgroundColor: '#F5EDE4'
    }} data-id="element-235">
        <div className="max-w-4xl mx-auto" data-id="element-236">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} data-id="element-237">
            <span className="text-sm font-bold tracking-[0.2em] uppercase mb-3 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-238">
              ⚠️ LO QUE ESTÁ PASANDO AHORA
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-10" style={{
            color: '#1A1614'
          }} data-id="element-239">
              El mercado cambió.
            </h2>

            {/* Comparison image */}
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5
          }} className="rounded-2xl overflow-hidden shadow-xl mb-8 md:mb-12" data-id="element-240">
              <img src="https://cdn.magicpatterns.com/uploads/17WRtnb6akbaqhANLyWSeY/ChatGPT_Image_27_mar_2026,_09_41_08_p.m..png" alt="Comparación: cinnamon roll casero vs XL estilo bakery" className="w-full object-cover" style={{
              maxHeight: '320px'
            }} data-id="element-241" />
            </motion.div>

            <div className="space-y-4 md:space-y-6 mb-8 md:mb-12" data-id="element-242">
              <p className="text-base md:text-xl" style={{
              color: '#5a5248'
            }} data-id="element-243">
                Las redes cambiaron. La percepción cambió.
              </p>
              <p className="text-base md:text-xl" style={{
              color: '#5a5248'
            }} data-id="element-244">
                Los productos con mayor volumen y altura generan más guardados y
                compartidos que versiones tradicionales.
              </p>
              <p className="text-base md:text-xl font-bold" style={{
              color: '#1A1614'
            }} data-id="element-245">
                Y eso importa porque:
              </p>
            </div>

            {/* Dynamic visual flow */}
            <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-10 shadow-lg mb-8 md:mb-12 overflow-hidden relative" data-id="element-246">
              <div className="absolute top-0 left-0 w-full h-1" style={{
              background: 'linear-gradient(90deg, #e76f51, #f4a261, #e76f51)'
            }} data-id="element-247" />
              <div className="space-y-3 md:space-y-4" data-id="element-248">
                {[{
                icon: BookmarkIcon,
                text: 'Más guardados',
                result: 'más alcance.',
                color: '#e76f51'
              }, {
                icon: EyeIcon,
                text: 'Más alcance',
                result: 'más deseo.',
                color: '#f4a261'
              }, {
                icon: TrendingUpIcon,
                text: 'Más deseo',
                result: 'más ventas potenciales.',
                color: '#e76f51'
              }].map((item, i) => <motion.div key={i} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                margin: '-40px'
              }} transition={{
                duration: 0.4,
                delay: i * 0.15
              }} data-id="element-249">
                    <div className="flex items-center gap-3 md:gap-4" data-id="element-250">
                      <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                    backgroundColor: `${item.color}15`
                  }} data-id="element-251">
                        <item.icon className="w-5 h-5 md:w-6 md:h-6" style={{
                      color: item.color
                    }} data-id="element-252" />
                      </div>
                      <div className="flex items-center gap-1.5 md:gap-2 flex-wrap" data-id="element-253">
                        <span className="text-base md:text-2xl font-bold" style={{
                      color: item.color
                    }} data-id="element-254">
                          {item.text}
                        </span>
                        <span className="text-base md:text-2xl font-bold" style={{
                      color: '#1A1614'
                    }} data-id="element-255">
                          =
                        </span>
                        <span className="text-base md:text-2xl font-bold" style={{
                      color: item.color
                    }} data-id="element-256">
                          {item.result}
                        </span>
                      </div>
                    </div>
                    {i < 2 && <div className="flex justify-start pl-4 md:pl-5 py-0.5 md:py-1" data-id="element-257">
                        <ArrowDownIcon className="w-4 h-4 md:w-5 md:h-5" style={{
                    color: '#D4C4B0'
                  }} data-id="element-258" />
                      </div>}
                  </motion.div>)}
              </div>
            </div>

            {/* Hoy — with icons */}
            <p className="text-base md:text-xl font-medium mb-4 md:mb-6" style={{
            color: '#1A1614'
          }} data-id="element-259">
              Hoy:
            </p>
            <div className="space-y-3 md:space-y-4 mb-8 md:mb-10" data-id="element-260">
              {[{
              icon: MinusCircleIcon,
              text: 'Los rolls pequeños no destacan.'
            }, {
              icon: EyeOffIcon,
              text: 'Los tradicionales no se comparten.'
            }, {
              icon: TrendingDownIcon,
              text: 'Los planos no generan impacto.'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -12
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.35,
              delay: i * 0.1
            }} className="flex items-center gap-3 md:gap-4 bg-white rounded-xl md:rounded-2xl p-4 md:p-5 shadow-sm border border-gray-100" data-id="element-261">
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(231,111,81,0.1)'
              }} data-id="element-262">
                    <item.icon className="w-4 h-4 md:w-5 md:h-5" style={{
                  color: '#e76f51'
                }} data-id="element-263" />
                  </div>
                  <p className="text-sm md:text-lg font-medium" style={{
                color: '#5a5248'
              }} data-id="element-264">
                    {item.text}
                  </p>
                </motion.div>)}
            </div>

            <div className="text-center pt-2 md:pt-4" data-id="element-265">
              <p className="text-base md:text-xl italic mb-3 md:mb-4" style={{
              color: '#5a5248'
            }} data-id="element-266">
                Mientras lees esto…
              </p>
              <p className="text-xl md:text-3xl font-bold" style={{
              color: '#1A1614'
            }} data-id="element-267">
                Alguien más está lanzando su versión XL.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Full-width image on mobile, centered portrait on tablet/desktop */}
        <div className="relative mt-8 md:mt-10 overflow-hidden -mx-4 md:mx-0" data-id="element-268">
          <div className="absolute top-0 left-0 right-0 z-10" style={{
          height: '30%',
          background: 'linear-gradient(to bottom, #F5EDE4, transparent)'
        }} data-id="element-269" />
          {/* Mobile: full width like before */}
          <img src="https://cdn.magicpatterns.com/uploads/9SjMsjvsMvZeyYbyxvXwKj/ChatGPT_Image_1_abr_2026,_07_33_04_a.m..png" alt="Emely con bandeja de cinnamon rolls XL y libro Edición Coleccionable" className="w-full object-cover block md:hidden" style={{
          maxHeight: '400px',
          transform: 'scale(1.08)'
        }} data-id="element-270" />
          {/* Tablet/Desktop: centered with natural portrait proportion */}
          <img src="https://cdn.magicpatterns.com/uploads/9SjMsjvsMvZeyYbyxvXwKj/ChatGPT_Image_1_abr_2026,_07_33_04_a.m..png" alt="Emely con bandeja de cinnamon rolls XL y libro Edición Coleccionable" className="hidden md:block mx-auto rounded-3xl shadow-xl object-cover" style={{
          maxWidth: '520px',
          maxHeight: '650px',
          width: '100%'
        }} data-id="element-271" />
        </div>
      </section>
    </>;
}